import { OrderTrackingSummary } from '@delivery/tracking';
import { Typography } from '@one-thd/sui-atomic-components';
import { Clock } from '@one-thd/sui-icons';
import React from 'react';
import { IOrderDetailsResponse } from '../../models/order-details';
import {
  IOrder,
  ITrackingDetails,
  Layout,
} from '../../models/purchase-history';
import { getWindow } from '../../utils/general';
import { statusStepperData } from '../../utils/order-history/card-utils';
import { dateFormat } from '../order-details/util/format';
import { CardTrackingDetails } from '../purchase-history/card-view/index';
import { ProductImages } from '../purchase-history/table-view/index';
import { PreShipOrderStatus } from './PreShipOrderStatus';
import './TrackingDetails.scss';
import { ODOrderStatus } from '../purchase-history/delivery-tracker/ODOrderStatus';

export const TrackingDetails = ({
  isLoading,
  isMobile,
  item,
  orderNumber,
  record,
  trackingNumber,
  workOrderNumber,
  layout,
  view,
  deliveryTrackerData,
  deliveryTrackerLoaded,
}: ITrackingDetails) => {
  if (
    ['Canceled', 'Returned', 'Ready for Pickup'].includes(
      item?.lineItems?.[0]?.statusDescription ?? '',
    )
  ) {
    return null;
  }

  const getHostUrl = () => {
    if (
      getWindow()?.location?.host?.includes('hd-qa71') ||
      getWindow()?.location?.host?.includes('hd-qa74')
    ) {
      return 'https://delivery-tracker.np-sc-delivery-execution.gcp.homedepot.com';
    }
    return 'https://delivery-tracker.pr-sc-delivery-execution.gcp.homedepot.com';
  };

  if (item?.fulfillmentType === 'BuyOnlinePickupInStore') {
    if (item?.lineItems?.[0]?.statusDescription === 'Complete') {
      return (
        <Typography weight="bold">
          Picked up{' '}
          {dateFormat(item?.lineItems?.[0]?.pickedUpDate, 'EEEE, MMMM d')}
        </Typography>
      );
    }
    return (
      <CardTrackingDetails
        item={item}
        imagesLength={item?.lineItems?.length ?? 0}
        orderStatus={statusStepperData(
          item?.lineItems?.[0] ?? null,
          'statusDescription',
          item?.fulfillmentType,
        )}
        isMobile={isMobile}
        orderNumber={
          record?.orderNumber ??
          (record as IOrderDetailsResponse | IOrder)?.orderNumbers?.[0]
        }
        date={(record as IOrderDetailsResponse)?.createDateTime}
      />
    );
  }

  if (
    [
      'APPLIANCE',
      'Appliance',
      'BuyOnlineDeliverFromStore',
      'ShipToHome',
      'DFS',
      'BuyOnlineShipToStore',
    ].includes(item?.fulfillmentType)
  ) {
    // Tracker library only works for MA/DFS/STH/BOSS/BODFS, will not work for BOPIS
    return (
      <div className={layout === 'CARD' ? '' : 'tracking-fix'}>
        {(() => {
          if (view === 'LOCAL_DELIVERIES') {
            return (
              <ODOrderStatus
                deliveryTrackerData={deliveryTrackerData}
                deliveryTrackerLoaded={deliveryTrackerLoaded}
                fulfillmentGroup={item}
                fulfillmentType={item?.fulfillmentType}
                salesDate={record?.salesDate}
              />
            );
          }
          if (item?.lineItems?.[0]?.statusDescription === 'Being Processed') {
            const formatDate = 'EEEE, MMMM d';
            const bodfsDeliveryText =
              item?.bodfsDeliveryAndHandling?.bodfsDeliveries?.[0]
                ?.reservationWindowDisplayText || '';

            return (
              <PreShipOrderStatus>
                {(item?.shippingAndHandling?.applianceDeliveries?.[0]
                  ?.currentDeliveryDate ||
                  bodfsDeliveryText ||
                  item?.shippingAndHandling?.estEndDeliveryDate) && (
                  <Typography variant="body-base" weight="bold">
                    {item?.isPendingCancellation && <Clock size="small" />}
                    {item?.isPendingCancellation && ' '}
                    {item?.fulfillmentType !== 'MISC' &&
                      bodfsDeliveryText === '' &&
                      `Estimated Arrival - ${dateFormat(
                        item?.shippingAndHandling?.applianceDeliveries?.[0]
                          ?.currentDeliveryDate ||
                          item?.shippingAndHandling?.estEndDeliveryDate,
                        formatDate,
                      )}`}
                    {item?.fulfillmentType !== 'MISC' &&
                      bodfsDeliveryText &&
                      `Estimated Arrival - ${bodfsDeliveryText}`}{' '}
                  </Typography>
                )}
              </PreShipOrderStatus>
            );
          }
          return null;
        })()}
        <OrderTrackingSummary
          orderNumber={orderNumber?.toUpperCase()}
          // trackingNumber (for STH/BOSS)
          trackingNumber={trackingNumber?.toUpperCase()}
          // workOrderNumber (for MA/DFS)
          workOrderNumber={workOrderNumber?.toUpperCase()}
          host={getHostUrl()}
          layout={layout as Layout}
        >
          {(layout as Layout) === 'TABLE' ? (
            <div>
              <ProductImages
                isLoading={isLoading}
                lineItems={item?.lineItems ?? []}
                maxShow={5}
                variant="medium"
              />
            </div>
          ) : null}
        </OrderTrackingSummary>
      </div>
    );
  }

  return null;
};
